import { fetchWithAuth } from './fetchWithAuth'

export async function createTenant(
  token: string,
  body: Record<string, unknown>,
): Promise<void> {
  await fetchWithAuth('/v1/tenants', token, {
    method: 'POST',
    body: JSON.stringify(body),
  })
}
